// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider-banner img[data-v-3433e551] {\n  width: 100%;\n}\n@media screen and (max-width: 1023px) {\n.slider-banner[data-v-3433e551] {\n    display: none;\n}\n}", ""]);
// Exports
module.exports = exports;
